import { ReportsIcon } from 'foundations-assets/icons/components/ReportsIcon';
import { ReportingAndDataIcon } from 'foundations-assets/icons/components/ReportingAndDataIcon';
import { PersonCheckIcon } from 'foundations-assets/icons/components/PersonCheckIcon';
import { AutomationsIcon } from 'foundations-assets/icons/components/AutomationsIcon';
import { AudienceTargetingIcon } from 'foundations-assets/icons/components/AudienceTargetingIcon';
import { MessagesIcon } from 'foundations-assets/icons/components/MessagesIcon';
import { GoalIcon } from 'foundations-assets/icons/components/GoalIcon';
import { FormsIcon } from 'foundations-assets/icons/components/FormsIcon';

// @ts-expect-error dependency missing types
import ReportBuilderAndMultipleEmailSignaturesValueProp1 from 'bender-url!../../img/valuePropModals/ReportBuilderAndMultipleEmailSignatures/ValueProp1.svg';
// @ts-expect-error dependency missing types
import ReportBuilderAndMultipleEmailSignaturesValueProp2 from 'bender-url!../../img/valuePropModals/ReportBuilderAndMultipleEmailSignatures/ValueProp2.svg';
// @ts-expect-error dependency missing types
import ReportBuilderAndMultipleEmailSignaturesValueProp3 from 'bender-url!../../img/valuePropModals/ReportBuilderAndMultipleEmailSignatures/ValueProp3.svg';
// @ts-expect-error dependency missing types
import SequencesValueProp1 from 'bender-url!../../img/valuePropModals/SequencesEmailCommunicator/ValueProp1.svg';
// @ts-expect-error dependency missing types
import SequencesValueProp2 from 'bender-url!../../img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg';
// @ts-expect-error dependency missing types
import SequencesValueProp3 from 'bender-url!../../img/valuePropModals/SequencesEmailCommunicator/ValueProp3.svg';
// @ts-expect-error dependency missing types
import WhatsAppValueProp1 from 'bender-url!../../img/valuePropModals/WhatsApp/ValueProp1.svg';
// @ts-expect-error dependency missing types
import WhatsAppValueProp2 from 'bender-url!../../img/valuePropModals/WhatsApp/ValueProp2.svg';
// @ts-expect-error dependency missing types
import WhatsAppValueProp3 from 'bender-url!../../img/valuePropModals/WhatsApp/ValueProp3.svg';
// @ts-expect-error dependency missing types
import TeamNoAccessValueProp1 from 'bender-url!../../img/valuePropModals/TeamNoAccess/ValueProp1.svg';
// @ts-expect-error dependency missing types
import TeamNoAccessValueProp2 from 'bender-url!../../img/valuePropModals/TeamNoAccess/ValueProp2.svg';
// @ts-expect-error dependency missing types
import TeamNoAccessValueProp3 from 'bender-url!../../img/valuePropModals/TeamNoAccess/ValueProp3.svg';
// @ts-expect-error dependency missing types
import FormCondLogicValueProp1 from 'bender-url!../../img/valuePropModals/FormConditionalLogic/ValueProp1.svg';
// @ts-expect-error dependency missing types
import FormCondLogicValueProp2 from 'bender-url!../../img/valuePropModals/FormConditionalLogic/ValueProp2.svg';
// @ts-expect-error dependency missing types
import FormCondLogicValueProp3 from 'bender-url!../../img/valuePropModals/FormConditionalLogic/ValueProp3.svg';
export const VALUE_PROP_ACCENT_STYLES = [{
  iconColor: 'fill-accent-blue-default',
  iconBackground: 'fill-accent-blue-subtle-alt',
  iconBorderColor: 'border-accent-blue-default'
}, {
  iconColor: 'fill-accent-green-default',
  iconBackground: 'fill-accent-green-subtle-alt',
  iconBorderColor: 'border-accent-green-default'
}, {
  iconColor: 'border-caution-default',
  iconBackground: 'fill-accent-yellow-subtle-alt',
  iconBorderColor: 'border-caution-default'
}];
const MULTIPLE_EMAIL_SIGNATURES_KEY = 'multiple-email-signatures';
const REPORT_BUILDER_KEY = 'report-builder-discover-templates-create-report';
const SEQUENCES_KEY = 'sequences-email-communicator-pql-feature-lock';
const WHATSAPP_KEY = 'whatsapp-messaging-access-crm';
const TEAM_NO_ACCESS_KEY = 'team-no-access';
const FORM_CONDITIONAL_LOGIC_KEY = 'form-conditional-logic-upgrade';
export const VALUE_PROP_MODAL_CONFIGS = {
  [MULTIPLE_EMAIL_SIGNATURES_KEY]: {
    upgradeKey: MULTIPLE_EMAIL_SIGNATURES_KEY,
    headerKey: 'valuePropModals.multipleEmailSignatures.header',
    subheaderKey: 'valuePropModals.multipleEmailSignatures.subheader',
    summaryKey: 'valuePropModals.multipleEmailSignatures.valuePropSummary',
    valueProps: [{
      titleKey: 'valuePropModals.multipleEmailSignatures.valuePropTitle1',
      descriptionKey: 'valuePropModals.multipleEmailSignatures.valuePropDescription1',
      image: ReportBuilderAndMultipleEmailSignaturesValueProp1,
      icon: ReportsIcon
    }, {
      titleKey: 'valuePropModals.multipleEmailSignatures.valuePropTitle2',
      descriptionKey: 'valuePropModals.multipleEmailSignatures.valuePropDescription2',
      image: ReportBuilderAndMultipleEmailSignaturesValueProp2,
      icon: ReportingAndDataIcon
    }, {
      titleKey: 'valuePropModals.multipleEmailSignatures.valuePropTitle3',
      descriptionKey: 'valuePropModals.multipleEmailSignatures.valuePropDescription3',
      image: ReportBuilderAndMultipleEmailSignaturesValueProp3,
      icon: PersonCheckIcon
    }]
  },
  [REPORT_BUILDER_KEY]: {
    upgradeKey: REPORT_BUILDER_KEY,
    headerKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.header',
    subheaderKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.subheader',
    summaryKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropSummary',
    valueProps: [{
      titleKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropTitle1',
      descriptionKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropDescription1',
      image: ReportBuilderAndMultipleEmailSignaturesValueProp1,
      icon: ReportsIcon
    }, {
      titleKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropTitle2',
      descriptionKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropDescription2',
      image: ReportBuilderAndMultipleEmailSignaturesValueProp2,
      icon: ReportingAndDataIcon
    }, {
      titleKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropTitle3',
      descriptionKey: 'valuePropModals.reportBuilderDiscoverTemplatesCreateReport.valuePropDescription3',
      image: ReportBuilderAndMultipleEmailSignaturesValueProp3,
      icon: PersonCheckIcon
    }]
  },
  [SEQUENCES_KEY]: {
    upgradeKey: SEQUENCES_KEY,
    headerKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.header',
    subheaderKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.subheader',
    summaryKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropSummary',
    valueProps: [{
      titleKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropTitle1',
      descriptionKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropDescription1',
      image: SequencesValueProp1,
      icon: AutomationsIcon
    }, {
      titleKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropTitle2',
      descriptionKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropDescription2',
      image: SequencesValueProp2,
      icon: AudienceTargetingIcon
    }, {
      titleKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropTitle3',
      descriptionKey: 'valuePropModals.sequencesEmailCommunicatorPqlFeatureLock.valuePropDescription3',
      image: SequencesValueProp3,
      icon: ReportingAndDataIcon
    }]
  },
  [WHATSAPP_KEY]: {
    upgradeKey: WHATSAPP_KEY,
    headerKey: 'valuePropModals.whatsAppMessagingAccessCrm.header',
    subheaderKey: 'valuePropModals.whatsAppMessagingAccessCrm.subheader',
    summaryKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropSummary',
    valueProps: [{
      titleKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropTitle1',
      descriptionKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropDescription1',
      image: WhatsAppValueProp1,
      icon: MessagesIcon
    }, {
      titleKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropTitle2',
      descriptionKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropDescription2',
      image: WhatsAppValueProp2,
      icon: AutomationsIcon
    }, {
      titleKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropTitle3',
      descriptionKey: 'valuePropModals.whatsAppMessagingAccessCrm.valuePropDescription3',
      image: WhatsAppValueProp3,
      icon: PersonCheckIcon
    }]
  },
  [TEAM_NO_ACCESS_KEY]: {
    upgradeKey: TEAM_NO_ACCESS_KEY,
    headerKey: 'valuePropModals.teamNoAccess.header',
    subheaderKey: 'valuePropModals.teamNoAccess.subheader',
    summaryKey: 'valuePropModals.teamNoAccess.valuePropSummary',
    valueProps: [{
      titleKey: 'valuePropModals.teamNoAccess.valuePropTitle1',
      descriptionKey: 'valuePropModals.teamNoAccess.valuePropDescription1',
      image: TeamNoAccessValueProp1,
      icon: GoalIcon
    }, {
      titleKey: 'valuePropModals.teamNoAccess.valuePropTitle2',
      descriptionKey: 'valuePropModals.teamNoAccess.valuePropDescription2',
      image: TeamNoAccessValueProp2,
      icon: PersonCheckIcon
    }, {
      titleKey: 'valuePropModals.teamNoAccess.valuePropTitle3',
      descriptionKey: 'valuePropModals.teamNoAccess.valuePropDescription3',
      image: TeamNoAccessValueProp3,
      icon: ReportsIcon
    }]
  },
  [FORM_CONDITIONAL_LOGIC_KEY]: {
    upgradeKey: FORM_CONDITIONAL_LOGIC_KEY,
    headerKey: 'valuePropModals.formConditionalLogic.header',
    subheaderKey: 'valuePropModals.formConditionalLogic.subheader',
    summaryKey: 'valuePropModals.formConditionalLogic.valuePropSummary',
    valueProps: [{
      titleKey: 'valuePropModals.formConditionalLogic.valuePropTitle1',
      descriptionKey: 'valuePropModals.formConditionalLogic.valuePropDescription1',
      image: FormCondLogicValueProp1,
      icon: AutomationsIcon
    }, {
      titleKey: 'valuePropModals.formConditionalLogic.valuePropTitle2',
      descriptionKey: 'valuePropModals.formConditionalLogic.valuePropDescription2',
      image: FormCondLogicValueProp2,
      icon: ReportingAndDataIcon
    }, {
      titleKey: 'valuePropModals.formConditionalLogic.valuePropTitle3',
      descriptionKey: 'valuePropModals.formConditionalLogic.valuePropDescription3',
      image: FormCondLogicValueProp3,
      icon: FormsIcon
    }]
  }
};